import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';

export const PaymentSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [sessionId, setSessionId] = useState<string | null>(null);
  const [userId, setUserId] = useState<string | null>(null);
  const [plan, setPlan] = useState<string | null>(null);

  useEffect(() => {
    const sessionIdParam = searchParams.get('session_id');
    const userIdParam = searchParams.get('user_id');
    const planParam = searchParams.get('plan');
    
    setSessionId(sessionIdParam);
    setUserId(userIdParam);
    setPlan(planParam);
    
    if (sessionIdParam && userIdParam && planParam) {
      console.log('決済成功:', { sessionId: sessionIdParam, userId: userIdParam, plan: planParam });
      
      // WebhookでFirestoreが更新されるまで少し待つ
      const t = setTimeout(() => {
        // SPA内遷移にすることでログイン状態を維持
        navigate('/?mode=app', { replace: true });
      }, 2000);
      return () => clearTimeout(t);
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="max-w-md w-full mx-4 text-center">
        <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-2xl font-bold text-slate-900 mb-4">
          決済が完了しました！
        </h1>
        
        <p className="text-slate-600 mb-6">
          ご利用いただき、ありがとうございます。<br />
          プランが正常に更新されました。
        </p>
        
        {sessionId && (
          <div className="bg-slate-50 rounded-lg p-4 mb-6">
            <p className="text-sm text-slate-500">セッションID</p>
            <p className="text-xs text-slate-400 font-mono">{sessionId}</p>
          </div>
        )}
        
        <div className="space-y-3">
          <button
            onClick={() => navigate('/')}
            className="w-full bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors"
          >
            ホームに戻る
          </button>
          
          <button
            onClick={() => navigate('/?mode=app')}
            className="w-full border border-slate-300 text-slate-700 py-3 px-6 rounded-lg font-semibold hover:bg-slate-50 transition-colors"
          >
            アプリを使用する
          </button>
        </div>
      </div>
    </div>
  );
};
